<template>
  <div>
    <transition name="fade">
      <div class="card-container" v-if="showPopup">
        <div class="follow-card">
          <div class="img-desc">
            {{title}}
          </div>
          <div class="img-box">
            <img :src="url">
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "MpPopupCard",
    props: {
      scene: {},
    },
    data() {
      return {
        url: "",
        title: "",
        name: "",
        popupDelay: 0,
        showPopup: false,
      }
    },
    mounted() {
      this.getMpPopup()
    },
    methods: {
      getMpPopup() {
        let params = {
          "scene": this.scene
        }
        this.$store.dispatch("MpRecommendByScene", params).then((data) => {
          if (data.code === 0) {
            this.url = data.data.url
            this.name = data.data.name
            this.title = data.data.title
            this.popupDelay = data.data.delay_ms || 0
          }

          if (this.url) {
            setTimeout(() => {
              this.showPopup = true
            }, this.popupDelay)
          }
        }, () => {

        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-container {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
  }

  .follow-card {
    padding: 24px;
    background: rgba(244, 245, 255, 0.72);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .img-box {
      width: 80px;
      height: 80px;
      flex: 0 0 auto;

      img {
        width: 100%;
      }
    }

    .img-desc {
      color: rgba(0, 0, 0, 0.8);
      margin-left: 12px;
      font-size: 16px;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>
